import IconAudio from '../../../img/fileTypes/audio.png'
import IconExcel from '../../../img/fileTypes/excel.png'
import IconPdf from '../../../img/fileTypes/pdf.png'
import IconPke from '../../../img/fileTypes/package.png'
import IconPpt from '../../../img/fileTypes/pptx.png'
import IconWord from '../../../img/fileTypes/word.png'
import IconOther from '../../../img/fileTypes/other.png'

export const fileFormat = (item) => {
  switch (item) {
    case "mp3":
    case "wav":
      return IconAudio
    case "ppt":
    case "pptx":
      return IconPpt
    case "pdf":
      return IconPdf
    case "rar":
    case "zip":
      return IconPke
    case "doc":
    case "docx":
    case "dot":
    case "dotx":
    case "docm":
      return IconWord
    case "xls":
    case "xlsx":
    case "xlsm":
    case "xlsb":
      return IconExcel
    default:
      return IconOther
  }
}